import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { createHttpParams } from '../utils/http-utils';
import { PortActivity } from '../interfaces/ports-activity.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PortsService {
  http = inject(HttpClient);

  getPorts(): Observable<string[]> {
    return this.http.get<string[]>('ports', { params: { airlineCode: 'PC' } });
  }

  getPortsActivity(
    portCode?: string,
    unit?: string,
    start?: string,
    end?: string,
    machineType?: string,
  ): Observable<PortActivity> {
    const params = createHttpParams({
      machineType,
      portCode,
      unit,
      start,
      end,
      airlineCode: 'PC',
    });

    return this.http.get<PortActivity>('ports/activity', { params });
  }

  getPortsActivityCount(): Observable<{ [key: string]: number }> {
    return this.http.get<{ [key: string]: number }>('ports/activity-count', { params: { airlineCode: 'PC' } });
  }
}
